import React, { useState, useRef, useContext, useEffect } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { useHotkeys } from 'react-hotkeys-hook';
// import Avatar from "react-avatar-edit";

import '../assets/css/modal.css';
import validErr from '../assets/js/valida'
import coords from '../data/coords.json';
import countryMap from '../data/country-map.json';

//Contexto
import ConexContext from "../context/conex/ConexContext";

import { ReactComponent as DojoIcon } from "../assets/img/iconos/acae_dojo.svg";
import { ReactComponent as GuardarIcon } from "../assets/img/iconos/acae_save.svg";
import { ReactComponent as CloseIcon } from "../assets/img/close2.svg";
import { ReactComponent as NewimgIcon } from "../assets/img/iconos/acae_new_img.svg";
import CursoCartelMod from './CursoCartelMod';

const DojosMod = (props) => {
	const {
		peticion,
		perfil_admin,
		perfil_asoc,
		loc,
		Cargando
	} = useContext(ConexContext)
	const navigate = useNavigate();
	const { lang } = useParams();

	//STATES
	const [Imagen, setImagen] = useState(null); //imagen del avatar
	// const [ClassAvatar, setClassAvatar] = useState("avCerrado"); //clase para el crop del avatar
	const [ClassCurso, setClassCurso] = useState('cursoCerrado');
	const [RutAvatar, setRutAvatar] = useState(null); //ruta del avatar
	const [ErrNombre, setErrNombre] = useState('')// Error en el nombre
	const [ErrCiudad, setErrCiudad] = useState('')// Error en la ciudad
	const [ErrAsoc, setErrAsoc] = useState('')// Error de la asoc
	const [ErrProvincia, setErrProvincia] = useState('')// Error en el provincia
	const [ErrPais, setErrPais] = useState('')// Error en el pais
	const [ErrWeb, setErrWeb] = useState('')// Error en el web
	const [ErrMaps, setErrMaps] = useState('')// Error en el Maps
	const [ErrDireccion, setErrDireccion] = useState('')// Error en el Direccion
	const [ErrTelfCont, setErrTelfCont] = useState('')// Error en el TelfCont
	const [ErrPersoCont, setErrPersoCont] = useState('')// Error en el PersoCont
	const [ErrCorreoE, setErrCorreoE] = useState('')// Error en el CorreoE
	const [ErrHorario, setErrHorario] = useState('')// Error en el Horario
	const [Asociaciones, setAsociaciones] = useState([])//clase con las asociaciones
	const [IdAsociacion, setIdAsociacion] = useState(0)//asociación del select
	const [IdPais, setIdPais] = useState(0)//pais del select
	const [IdProvincia, setIdProvincia] = useState(0)//provincia del select
	const [Estado, setEstado] = useState('')
	const [Visible, setVisible] = useState(false)

	//atajos de teclado
	useHotkeys('alt+g', guarda, { enableOnContentEditable: true, enableOnFormTags: true, enabled: props.show !== 0 && !Cargando })
	useHotkeys('esc', cierra, { enableOnContentEditable: true, enableOnFormTags: true, enabled: props.show !== 0 && !Cargando })

	//REFs
	const rId = useRef();
	const rNombre = useRef();
	const rCiudad = useRef();
	const rAsoc = useRef();
	const rProvincia = useRef();
	const rPais = useRef();
	const rWeb = useRef();
	const rMaps = useRef();
	const rDireccion = useRef();
	const rTelfCont = useRef();
	const rPersoCont = useRef();
	const rCorreoE = useRef();
	const rHorario = useRef();

	//EFFECT
	useEffect(() => {
		async function ver() {
			const pet = await peticion('/dojos/ver?id=' + props.show)
			if (pet.estado)//algún error 
				return;
			try {
				rId.current.value = pet.res.idDojo
				rNombre.current.value = pet.res.nombre
				rCiudad.current.value = pet.res.ciudad
				setIdAsociacion(pet.res?.cfAsoc ?? 0)
				rNombre.current.focus()
				rNombre.current.select()
				setRutAvatar(pet?.res?.avatar ?? null);
				setIdProvincia(pet.res?.provincia ?? null)
				setIdPais(pet.res?.pais ?? null)
				rWeb.current.value = pet.res?.web ?? null
				rMaps.current.value = pet.res?.maps ?? null
				rDireccion.current.value = pet.res?.direccion ?? null
				rTelfCont.current.value = pet.res?.telfcont ?? null
				rPersoCont.current.value = pet.res?.persocont ?? null
				rCorreoE.current.value = pet.res?.correoE ?? null
				rHorario.current.value = pet.res?.horario ?? null
				setVisible(pet.res?.visible ?? false)
			} catch (e) { }
		}
		async function verAsocs() {//descargo las Asociaciones
			const pet = await peticion('/asocs/?ini=0&pag=1000&orden=nombre&filtro=')
			if (pet.estado) //algún error
				return;
			setAsociaciones(pet?.res ?? [])
		}
		if (props.show === 0)
			return
		verAsocs()
		if (props.show > 0)
			ver()
		else if (props.show < 0) {//INSERTANDO
			rId.current.value = ''
			rNombre.current.value = ''
			rCiudad.current.value = ''
			rProvincia.current.value = ''
			rPais.current.value = ''
			rWeb.current.value = ''
			rMaps.current.value = ''
			rDireccion.current.value = ''
			rTelfCont.current.value = ''
			rPersoCont.current.value = ''
			rCorreoE.current.value = ''
			rHorario.current.value = ''
			setIdPais(0)
			setIdProvincia(0)
			setVisible(false)
			let asoc = props.ListParams.idAsoc
			if (!perfil_admin)
				asoc = perfil_asoc
			setIdAsociacion(asoc)
			rNombre.current.focus()

		}
	}, [props.show, peticion, perfil_admin, perfil_asoc, props.ListParams])

	// guardar el registro
	async function guarda() {
		//filtros sin necesidad de peticiones
		let error = false
		//requeridos
		error |= validErr(rNombre.current.value === '', setErrNombre, loc('El nombre es requerido.'))
		error |= validErr(rCiudad.current.value === '', setErrCiudad, loc('La ciudad es requerida.'))
		error |= validErr(rAsoc.current.value === '0', setErrAsoc, loc('La asociación es requerida.'))
		if (!perfil_admin && !error)//es perfil de adm asoc, solo guardar en la asov suya
			error |= validErr(parseInt(rAsoc.current.value) !== perfil_asoc, setErrAsoc, loc('Solo puedes guardar en tu asociación.'))

		error |= validErr(rPais.current.value.trim() === '0', setErrPais, loc('El país es requerido.'))
		error |= validErr(rProvincia.current.value.trim() === '0', setErrProvincia, loc('La provincia es requerida.'))

		// inline regex: requerir http(s) y no contener espacios
		const urlRegex = /^https?:\/\/[\S]+$/i;
		// validar Web y Maps si están rellenados
		if (rWeb.current.value && !urlRegex.test(rWeb.current.value)) {
			setErrWeb(loc('Introduce una URL válida (https://...)'))
			return;
		}
		if (rMaps.current.value && !urlRegex.test(rMaps.current.value)) {
			setErrMaps(loc('Introduce una URL válida (https://...)'))
			return;
		}

		if (error)//algún error
			return;
		//filtros con peticiones
		let pet
		//comprobamos que nombre no está repetido
		pet = await peticion(`/dojos/rep_nombre?nombre=${rNombre.current.value}&id=${props.show}&idAsoc=${IdAsociacion}`)
		if (!pet?.estado ?? 1)//estado OK
			if ((pet?.res?.idDojo ?? 1) > -1) {
				setErrNombre(loc('Ya existe un dojo con ese nombre en la asociación.'))
				return;
			}
		if (props.show < 0)//inserción
			pet = await peticion('/dojos/ins', {
				method: 'POST',
				json: {
					nombre: rNombre.current.value,
					ciudad: rCiudad.current.value,
					idAsoc: IdAsociacion,
					Provincia: IdProvincia,
					Pais: IdPais,
					Web: rWeb.current.value,
					Direccion: rDireccion.current.value,
					TelfCont: rTelfCont.current.value,
					PersoCont: rPersoCont.current.value,
					CorreoE: rCorreoE.current.value,
					Horario: rHorario.current.value,
					avatar: Imagen,
					visible: Visible,
					Maps: rMaps.current.value
				}
			})
		else if (props.show > 0)//modificación
			pet = await peticion('/dojos/mod', {
				method: 'POST',
				json: {
					id: rId.current.value,
					nombre: rNombre.current.value,
					ciudad: rCiudad.current.value,
					idAsoc: IdAsociacion,
					Provincia: IdProvincia,
					Pais: IdPais,
					Web: rWeb.current.value,
					Direccion: rDireccion.current.value,
					TelfCont: rTelfCont.current.value,
					PersoCont: rPersoCont.current.value,
					CorreoE: rCorreoE.current.value,
					Horario: rHorario.current.value,
					avatar: Imagen,
					visible: Visible,
					Maps: rMaps.current.value
				}
			})
		let id = pet?.res?.id ?? rId.current.value
		if (pet.estado)//algún error 
			return;
		cierra()
		if (parseInt(id) === props.ListParams.idReg)
			props.setListParams((prev) => ({ ...prev }))
		else
			navigate(`/${lang}/app/dojos/asoc_${props.ListParams.idAsoc}/${id}`)
	}
	//cierra el modal
	function cierra() {
		setEstado('')
		setErrNombre('')
		setErrCiudad('')
		setErrAsoc('')
		setErrProvincia('')
		setErrPais('')
		setErrWeb('')
		setErrMaps('')
		setErrDireccion('')
		setErrTelfCont('')
		setErrPersoCont('')
		setErrCorreoE('')
		setErrHorario('')
		setImagen(null);
		props.onHide()
	}


	// if (!perfil_admin && !perfil_adm_asoc)
	// 	return ("")
	if (props.show === 0)
		return ("")
	else
		return (
			<main className="modal-wrapper">
				<div className="modal-container backdrop content-wrapper">
					<div className='modal-header'>
						<div className='flex-wrapper'>
							<DojoIcon className='section-icon dojos' />
							<h3>{props.show > 0 ? loc('Modificar dojo') : loc('Nuevo dojo')}</h3>
						</div>
						<CloseIcon onClick={() => {
							if (Estado === "modificado") {
								Swal.fire({
									title: loc("¿Hay valores modificados, estás seguro que quieres salir sin aplicar los cambios?"),
									showCancelButton: true,
									confirmButtonText: loc("Sí"),
									icon: "question",
									cancelButtonText: loc("No"),
								}).then((result) => {
									if (result.isConfirmed) {
										cierra();
									}
								})
							} else {
								cierra();
							}
						}} className='modal_close-icon' alt='Cerrar ventana' title='(ESC)' />
					</div>
					<form className="modal-content-scroll form-container">
						<div className="modal-content-outer-wrapper">
							<div className="form-scroll">
								<div className='flex-row-item align-start'>
									<div className="upload-logodojo-img__wrapper">
										{(RutAvatar || Imagen) ? (
											<img
												className="upload-logodojo-img__img"
												alt="Imagen del Dojo"
												src={
													Imagen !== null
														? Imagen
														: RutAvatar
														? `/dojo/${RutAvatar}`
														: "/dojo/default.png"
												}
											/>
										) : (
											<div className="upload-logodojo-img__default">Sin logo</div>
										)}
										<NewimgIcon className='newimg-icon' onClick={() => { setClassCurso(ClassCurso === 'cursoAbierto' ? ('cursoCerrado') : ('cursoAbierto')) }} />
									</div>
									<div className='flex-column space-between'>
										<div className='relative-container flex-row-item gap-small checkbox-container'>
											<input
												id='visible-checkbox'
												type="checkbox"
												className='carnet-checkbox m0'
												checked={Visible}
												onChange={(e) => {
													setEstado("modificado");
													setVisible(e.target.checked);
												}}
											/>
											<label htmlFor='visible-checkbox'>{loc('Dojo visible en el mapa')}</label>
										</div>
										<div className='flex-column no-gap'>
											<div>
												<h2 className='dojo-card__nombre'>{rNombre?.current?.value ?? ''}</h2>
											</div>
											<div>
												<p className='dojo-card__asociacion'>{Asociaciones.find((a) => a.idAsoc.toString() === IdAsociacion.toString())?.nombre ?? ''}</p>
											</div>
										</div>
									</div>
								</div>
								<div className="horizontal-divider"></div>
								<div className='dojos-data'>
									<div className="column-duo underline relative-container">
										<input ref={rId} type='hidden' />
										<p>{loc('Nombre')}</p>
										<input ref={rNombre}
											onChange={() => { setEstado('modificado'); setErrNombre('') }}
											placeholder={loc('Nombre del dojo')}
											maxLength={50} />
										<p className='error'>{ErrNombre}</p>
									</div>
									<div className='relative-container'>
										<p>{loc('Ciudad')}</p>
										<input ref={rCiudad}
											onChange={() => { setEstado('modificado'); setErrCiudad('') }}
											placeholder={loc('Ciudad donde está el dojo')}
											maxLength={50} />
										<p className='error'>{ErrCiudad}</p>
									</div>
									<div className='relative-container'>
										<p>{loc('Asociación')}</p>
										<select
											ref={rAsoc}
											value={IdAsociacion}
											onChange={() => { setEstado('modificado'); setIdAsociacion(rAsoc.current.value) }}>
											<option value={0}>{loc('Seleccionar asociación')}</option>
											{Asociaciones.map(
												(elem) => (
													<option value={elem.idAsoc} key={elem.idAsoc}>{elem.nombre} ({elem.zona})</option>
												))
											}
										</select>
										<p className='error'>{ErrAsoc}</p>
									</div>
									<div className='relative-container'>
										<p>{loc('País')}</p>
										<select
											ref={rPais}
											value={IdPais}
											onChange={() => {
												setEstado('modificado');
												setErrPais('');
												setIdPais(rPais.current.value)
												if (rPais.current.value.trim() === "0") {
													setIdProvincia(0)
												}
											}}>
											<option value={0}>{loc('Seleccionar país')}</option>
											{Object.keys(countryMap).map(
												(elem) => (
													<option value={countryMap[elem].code} key={countryMap[elem].code}>{countryMap[elem]?.name}</option>
												))
											}
										</select>
										<p className='error'>{ErrPais}</p>
									</div>
									<div className='relative-container'>
										<p>{loc('Provincia')}</p>
										<select
											ref={rProvincia}
											value={IdProvincia}
											onChange={() => {
												setEstado('modificado');
												setErrProvincia('');
												setIdProvincia(rProvincia.current.value)
											}}>
											<option value={0}>{loc('Seleccionar provincia')}</option>
											{coords[IdPais] && Object.keys(coords[IdPais]).map(
												(elem) => (
													<option value={elem} key={elem}>{coords[IdPais][elem]?.nombre}</option>
												))
											}
										</select>
										<p className='error'>{ErrProvincia}</p>
									</div>
									<div className='relative-container column-duo overline underline'>
										<p>{loc('Dirección')}</p>
										<input ref={rDireccion}
											onChange={() => { setEstado('modificado'); setErrDireccion('') }}
											placeholder={loc('Dirección')}
											maxLength={50} />
										<p className='error'>{ErrDireccion}</p>
									</div>
									<div className='relative-container'>
										<p>{loc('Web')}</p>
										<input ref={rWeb}
											onChange={() => { setEstado('modificado'); setErrWeb('') }}
											onBlur={() => {
												const urlRegex = /^https?:\/\/[\S]+$/i;
												if (rWeb.current.value && !urlRegex.test(rWeb.current.value))
													setErrWeb(loc('Introduce una URL válida (https://...)'))
												else
													setErrWeb('')
											}}
											placeholder={loc('Web')}
											maxLength={50} />
										<p className='error'>{ErrWeb}</p>
									</div>
									<div className='relative-container'>
										<p>{loc('Enlace a Google Maps')}</p>
										<input ref={rMaps}
											onChange={() => { setEstado('modificado'); setErrMaps('') }}
											onBlur={() => {
												const urlRegex = /^https?:\/\/[\S]+$/i;
												if (rMaps.current.value && !urlRegex.test(rMaps.current.value))
													setErrMaps(loc('Introduce una URL válida (https://...)'))
												else
													setErrMaps('')
											}}
											placeholder={loc('Enlace a Google Maps')}
											maxLength={50} />
										<p className='error'>{ErrMaps}</p>
									</div>
									<div className='relative-container'>
										<p>{loc('Teléfono de contacto')}</p>
										<input ref={rTelfCont}
											onChange={() => { setEstado('modificado'); setErrTelfCont('') }}
											placeholder={loc('Teléfono de contacto')}
											maxLength={9} />
										<p className='error'>{ErrTelfCont}</p>
									</div>
									<div className='relative-container'>
										<p>{loc('Persona de contacto')}</p>
										<input ref={rPersoCont}
											onChange={() => { setEstado('modificado'); setErrPersoCont('') }}
											placeholder={loc('Persona de contacto')}
											maxLength={50} />
										<p className='error'>{ErrPersoCont}</p>
									</div>
									<div className='relative-container'>
										<p>{loc('Correo electrónico')}</p>
										<input ref={rCorreoE}
											onChange={() => { setEstado('modificado'); setErrCorreoE('') }}
											placeholder={loc('Correo electrónico')}
											maxLength={50} />
										<p className='error'>{ErrCorreoE}</p>
									</div>
									<div className='relative-container'>
										<p>{loc('Horario')}</p>
										<textarea ref={rHorario}
											onChange={() => { setEstado('modificado'); setErrHorario('') }}
											placeholder={loc('Horario')}
											maxLength={150} />
										<p className='error'>{ErrHorario}</p>
									</div>
								</div>
							</div>
						</div>
					</form>
					<div className='modal-footer'>
						<div className="flex-wrapper flex-end">
							<button
								type="button"
								onClick={guarda}
								className="button primary">{loc('Aplicar')}
								<GuardarIcon alt='Aplicar' title='Aplicar' />
							</button>
							<button
								className="button tertiary"
								onClick={() => {
									if (Estado === "modificado") {
										Swal.fire({
											title: loc("¿Hay valores modificados, estás seguro que quieres salir sin aplicar los cambios?"),
											showCancelButton: true,
											confirmButtonText: loc("Sí"),
											icon: "question",
											cancelButtonText: loc("No"),
										}).then((result) => {
											if (result.isConfirmed) {
												cierra();
											}
										})
									} else {
										cierra();
									}
								}}
							>
								{loc('Cancelar')}
							</button>
							<p className='error'></p>
						</div>
					</div>
				</div>
				{/* <div className={`img-avatar-wrapper ${ClassAvatar}`}>
					<div className="img-avatar-container">
						<Avatar
							className="img-avatar"
							imageHeight={400}
							onClose={() => {
								setClassAvatar("avCerrado");
								setImagen(null);
							}}
							onCrop={(img) => {
								setImagen(img);
							}}
							label={loc("Subir imagen")}
							exportSize={100}
							src={null}
						/>
						{Imagen !== null ? (
							<button
								type="button"
								className="cta"
								onClick={() => {
									setClassAvatar("avCerrado");
								}}>
								{loc("Aplicar")}
							</button>
						) : (
							<button
								type="button"
								className="cta avatar-cerrar"
								onClick={() => {
									setClassAvatar("avCerrado");
								}}>
								<CloseIcon />
							</button>
						)}
					</div>
					<div className="img-avatar-container__bg"></div>
				</div> */}
				<CursoCartelMod
					show={ClassCurso}
					image={"/curso/" + RutAvatar}
					Imagen={Imagen}
					setImagen={setImagen}
					setEstado={setEstado}
					cuadrado={true}
					onHide={() => setClassCurso('cursoCerrado')}
				/>
			</main >

		);
}

export default DojosMod;